import React, { useEffect } from 'react'
import Img1 from '../../assets/explores/spot1.jpg'
import Img2 from '../../assets/explores/spot2.jpg'
import Img3 from '../../assets/explores/spot3.jpg'
import Img4 from '../../assets/explores/spot4.jpg'
import Img5 from '../../assets/explores/spot5.jpg'
import Img6 from '../../assets/explores/spot6.jpg'
import Img7 from '../../assets/explores/spot7.jpg'
import Img8 from '../../assets/explores/spot8.jpg'
import Img9 from '../../assets/explores/spot9.jpg'
import Img10 from '../../assets/explores/spot10.jpg'
import Img11 from '../../assets/explores/spot11.jpg'
import Img12 from '../../assets/explores/spot12.jpg'
import Img13 from '../../assets/explores/spot13.jpg'
import Img14 from '../../assets/explores/spot14.jpg'
import Img15 from '../../assets/explores/spot15.jpg'
import Img16 from '../../assets/explores/spot16.jpg'
import Img17 from '../../assets/explores/spot17.jpg'
import Img18 from '../../assets/explores/spot18.jpg'
import Img19 from '../../assets/explores/spot19.jpg'
import Img20 from '../../assets/explores/spot20.jpg'
import Img21 from '../../assets/explores/spot21.jpg'
import Img22 from '../../assets/explores/spot22.jpg'
import Img23 from '../../assets/explores/spot23.jpg'
import Img24 from '../../assets/explores/spot24.jpg'
import ExploreCaousels from './ExploreCaousels'
import { FiArrowRight } from 'react-icons/fi'

const Explore = (props) => {

  useEffect(() => {

    const handleScroll = () => {
      const container = document.getElementById("explore")
      const leftElements = document.querySelectorAll(".explore-left")
      const rightElements = document.querySelectorAll(".explore-right")
      const { top } = container.getBoundingClientRect()
      const windoHeight = window.innerHeight

      if (top < windoHeight) {
        leftElements.forEach(element => {
          element.classList.add("visible")
        })
        rightElements.forEach(element => {
          element.classList.add("visible")
        })
      }
      else {
        leftElements.forEach(element => {
          element.classList.remove("visible")
        })
        rightElements.forEach(element => {
          element.classList.remove("visible")
        })
      }
    }

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };

  }, [])

  return (
    <section className='explore-container relative overflow-hidden py-12 text-center text-slate-100 sm:py-16' id="explore">
      <h2 className='mx-auto max-w-4xl px-4 font-["Gloock",serif] text-4xl font-semibold sm:text-5xl lg:text-6xl'>{props.title}</h2>
      <p className='mx-auto mt-4 max-w-3xl px-4 text-sm leading-relaxed text-slate-300 sm:text-base'>{props.desc}</p>
      <button
        className='group mt-6 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#092FB6] to-[#636DE5] px-6 py-3 text-sm font-semibold text-white shadow-[0_12px_30px_rgba(9,47,182,0.35)] transition hover:brightness-110 sm:text-base'
        onClick={() => props.navPage('/packages')}
      >
        {props.button}
        <FiArrowRight className='transition-transform duration-300 group-hover:translate-x-1' />
      </button>
      <span className='explore-carousel-container explore-carousel-container-1 explore-left'>
        <ExploreCaousels imgA={Img1} imgB={Img2} imgC={Img3} timer={2000} />
      </span>
      <span className='explore-carousel-container explore-carousel-container-2 explore-left'>
        <ExploreCaousels imgA={Img4} imgB={Img5} imgC={Img6} timer={1000} />
      </span>
      <span className='explore-carousel-container explore-carousel-container-3 explore-right'>
        <ExploreCaousels imgA={Img7} imgB={Img8} imgC={Img9} timer={3000} />
      </span>
      <span className='explore-carousel-container explore-carousel-container-4 explore-right'>
        <ExploreCaousels imgA={Img10} imgB={Img11} imgC={Img12} timer={5000} />
      </span>
      <span className='explore-carousel-container explore-carousel-container-5 explore-left'>
        <ExploreCaousels imgA={Img13} imgB={Img14} imgC={Img15} timer={4000} />
      </span>
      <span className='explore-carousel-container explore-carousel-container-6 explore-left'>
        <ExploreCaousels imgA={Img16} imgB={Img17} imgC={Img18} timer={6000} />
      </span>
      <span className='explore-carousel-container explore-carousel-container-7 explore-right'>
        <ExploreCaousels imgA={Img19} imgB={Img20} imgC={Img21} timer={7000} />
      </span>
      <span className='explore-carousel-container explore-carousel-container-8 explore-right'>
        <ExploreCaousels imgA={Img22} imgB={Img23} imgC={Img24} timer={500} />
      </span>

    </section>
  )
}

export default Explore
